<template>
    <div>
        <div class="text-center mb-3 pt">
            <p class="h4">
                ¡Gracias por inscribirte!
            </p>
            <p>
                {{ $t("gracias.n_pedido") }}:
                <b>{{ tpv_order }}</b>
            </p>
            <router-link :to="{ name: 'front.home' }" class="button large-button effect-button">
                <span>Volver al inicio</span>
            </router-link>
        </div>
        <div class="lightgray-content p-2 small-font mb-2 pb-2 border-bottom d-flex">
            <div class="d-flex w-100 justify-content-between">
                <div>
                    <div class="mb-3">
                        <span class="h3 text-italicy">
                            Categoría: {{ base.categoria_base.name }}
                        </span>
                    </div>
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h6>{{ $t("bases.deportista") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.nombre }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.apellidos }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.email }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.dni }}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-12">
                                <h6>{{ $t("bases.responsable") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.nombre_responsable }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.apellidos_responsable }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.email_responsable }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.dni_responsable }}
                                        </strong>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 mt-3" v-if="base.nombre_responsable_2">
                                <h6>{{ $t("bases.responsable2") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.nombre_responsable_2 }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.apellidos_responsable_2 }}
                                        </strong>
                                    </span>
                                </div>
                                <div >
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.email_responsable_2 }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.dni_responsable_2 }}
                                        </strong>
                                    </span>
                                </div>
                            </div>                       
                        </div>
                        <div class="row mt-3 mb-3">
                            <div class="col-12 col-md-12" v-if="base.representante">
                                <h6>{{ $t("bases.entrenador") }}</h6>
                                <div>
                                    <label>
                                        {{ $t("bases.nombre") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.representante.name }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.apellidos") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.representante.surnames }}
                                        </strong>
                                    </span>
                                </div>
                                <div >
                                    <label>
                                        {{ $t("bases.email") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.representante.email }}
                                        </strong>
                                    </span>
                                </div>
                                <div>
                                    <label>
                                        {{ $t("bases.DNI") }}:
                                    </label>
                                    <span>
                                        <strong>
                                            {{ base.representante.nif }}
                                        </strong>
                                    </span>
                                </div>
                            </div>      
                        </div>
                    </div>
                    <div>
                        <a
                            v-if="!base.categoria_base.indumentariasElegidas"
                            :href="base.url_descarga"
                            class="ml-3 button button-xs"
                            target="_blank"
                        >
                            DESCARGAR PDF
                        </a>
                    </div>                    
                    <div v-if="base.categoria_base.indumentariasElegidas && base.categoria_base.indumentariasElegidas.length > 0">
                        <label>
                            Indumentarias:
                        </label>
                        <span>
                            <strong>
                                {{ base.indumentariasElegidas.length > 1 ? base.indumentariasElegidas.map(i => i.nombre).join(', ') : base.indumentariasElegidas.map(i => i.nombre).join('') }}
                            </strong>
                        </span>
                        <a 
                            :href="base.url_descarga"
                            class="ml-3 button button-xs"
                            target="_blank"
                        >
                            DESCARGAR PDF
                        </a>
                    </div>
                    <div class="mt-3" v-if="base.categoria_base.activar_pago_plazos && base.categoria_base.plazos">
                        <span class="h3 text-italicy">
                            Plazos restantes:
                        </span>
                        <div class="mt-3 pl-3">
                            <template v-for="(plazo, index) in base.categoria_base.plazos">
                                <div :key="index">
                                    <p class="p-0 mt-1 h5" style="font-size: 18px;">
                                        {{ 
                                            base.categoria_base.price_management_interno_online
                                            ? 
                                            $t('bases.n_plazo_sin_gd', {
                                                dia: plazo.dia,
                                                importe_sin_gd: $n(plazo.importe, "currency")
                                            })
                                            :
                                            $t('bases.n_plazo_con_gd', {
                                                dia: plazo.dia,
                                                importe_sin_gd: $n(plazo.importe, "currency"),
                                                gd: $n(plazo.price_management, "currency")
                                            })
                                        }}
                                    </p>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                
                <div class="text-center ml-3">
                    <label>{{ !base.categoria_base.activar_pago_plazos || !base.categoria_base.plazos ? $t("gracias.precio") + ' total' : 'Precio primer plazo' }} </label><br />
                    <span class="h2">
                        <span class="ml-2 display-3 m-0">
                            {{ total | formatear_precio }}
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <span>
            <b>{{ $t("gracias.cuestion", { email: manager.email_incidencias ? manager.email_incidencias : "info@compralaentrada.com" }) }}</b>
        </span>
    </div>
</template>

<script>
export default {
    props: ['base', 'tpv_order'],
    created() {
        if (this.base.categoria_base.plazos) {
            this.base.categoria_base.plazos.shift();
        }
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        },
        total() {
            let precio = 0;
    
            if (this.base.categoria_base.plazos && this.base.categoria_base.plazos.length > 0) {
                precio += this.base.categoria_base.plazos[0].importe;
            } else {
                precio = precio + this.base.categoria_base.precio;

                if (this.base.indumentariasElegidas) {
                    this.base.indumentariasElegidas.forEach(indu => {
                        precio = precio + indu.precio_total;
                    });
                }
            }

            if (!this.base.categoria_base.price_management_interno_online) {
                precio = precio + this.base.categoria_base.price_management_online;
            }
    
            return precio;
        }
    }
}    
</script>